export default __webpack_public_path__ + "661409d7f5d2e11aa278b5d16cb9849c.png";